import Route from '@ember/routing/route';

export default class TermsRoute extends Route {}
